
                import "css-modules://src_components_slider"
                export default {"Main":"_fbca88","Eyebrow":"_a2c54c","Title":"_9c6871","Header":"_c41525","Items":"_00ed9b","Item":"_6cb22c","ItemTitle":"_74c999","Subline":"_66ad79","Text":"_fb9fa2"}
            